export default __webpack_public_path__ + "static/media/visualstudiocode.8f3d01d2.svg";